module.exports = __webpack_public_path__ + "static/img/1667304281872204.2e9c1f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/energy/1667304281872204.jpg
// module id = 5BBr
// module chunks = 4